import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import noImg from "@/assets/noimg.png";
import YYImage from '@/pages/design/components/basic/image';
import { mapState } from 'vuex';
export default {
  name: 'Banner',
  components: {
    YYImage: YYImage
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      screenWidth: 0,
      noImg: noImg
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    spacing: function spacing() {
      return this.formData.mBannerSpace;
    },
    moduleData: function moduleData() {
      var _this = this;
      // banner
      var tempBanner = [];
      // 18 为 banner之间的padding
      var padding = parseInt(this.formData.mBannerSpace);

      // 两边的padding 11 * 2
      var bannerWidth = (375 - (this.formData.mHorizontalPadding || 0) * 2 - padding * (this.formData.mSizeNum - 1)) / this.formData.mSizeNum;
      this.formData.pathLink.forEach(function (item) {
        tempBanner.push({
          style: {
            // 'background-image': 'url("'+ (this.imgHost + item.path) +'")',
            width: bannerWidth - padding + "px"
          },
          imgpath: item.path,
          styleSmall: {
            "background-image": 'url("' + item.path + '")',
            width: bannerWidth - padding * 2 + "px",
            height: _this.formData.mHeight + "px"
          },
          height: _this.formData.mHeight + "px",
          link: item.link,
          padding: padding / 2 + "px",
          outWidth: bannerWidth + "px"
        });
      });

      /* let pathlink = _.cloneDeep(this.formData.pathLink) */

      var arr = [];
      while (tempBanner.length > 0) {
        arr.push(tempBanner.splice(0, this.formData.mSizeNum));
      }
      return arr;
    },
    bannerStyle: function bannerStyle() {
      return function (key) {
        var width = Math.floor((this.screenWidth - this.getPx(this.spacing) * 2 - this.getPx(this.spacing) * (this.formData.mSizeNum - 1)) / this.formData.mSizeNum) + 'px';
        return {
          'paddingTop': (key < this.formData.mSizeNum ? 0 : this.getPx(this.spacing)) + 'px',
          'paddingRight': ((key + 1) % this.formData.mSizeNum == 0 ? 0 : this.getPx(this.spacing)) + 'px',
          'height': this.formData.mHeight + 'px',
          'width': width
        };
      };
    }
  }),
  mounted: function mounted() {
    this.screenWidth = this.$refs.rootRef.clientWidth;
    // let rowNum = Math.ceil(this.formData.pathLink.length/this.formData.mSizeNum);
    // for(let i=0; i< rowNum * this.formData.mSizeNum - this.formData.pathLink.length;i++)
    // {
    //   //console.log("余数",i)
    //   this.formData.pathLink.push({})
    // }
  },
  methods: {
    getPx: function getPx(pxValue) {
      return Math.floor(this.screenWidth / (375 / pxValue));
    },
    handleClick: function handleClick(link) {
      // if(link){
      //   window.location.href = link;
      // }
    }
  }
};